import { useTranslation } from "react-i18next";
import ScrollReveal from "./ScrollReveal";
import { Building2, Hotel, Hospital, Home } from "lucide-react";

const TargetSection = () => {
  const { t } = useTranslation();

  const segments = [
    {
      icon: <Home className="w-8 h-8" />,
      title: t("target.seg1Title"),
      body: t("target.seg1Body"),
      stat: t("target.seg1Stat"),
    },
    {
      icon: <Building2 className="w-8 h-8" />,
      title: t("target.seg2Title"),
      body: t("target.seg2Body"),
      stat: t("target.seg2Stat"),
    },
    {
      icon: <Hospital className="w-8 h-8" />,
      title: t("target.seg3Title"),
      body: t("target.seg3Body"),
      stat: t("target.seg3Stat"),
    },
    {
      icon: <Hotel className="w-8 h-8" />,
      title: t("target.seg4Title"),
      body: t("target.seg4Body"),
      stat: t("target.seg4Stat"),
    },
  ];

  return (
    <section id="pour-qui" className="py-8 lg:py-14 relative" aria-labelledby="target-heading">
      <div className="container mx-auto px-4">
        <ScrollReveal>
          <header className="text-center space-y-4 mb-12">
            <p className="section-label">{t("target.label")}</p>
            <h2 id="target-heading" className="font-display text-3xl lg:text-5xl text-foreground">
              {t("target.title")}
            </h2>
            <p className="text-muted-foreground font-body text-lg max-w-2xl mx-auto">
              {t("target.desc")}
            </p>
          </header>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {segments.map((seg, i) => (
            <ScrollReveal key={i} delay={i * 0.1}>
              <article className="card-surface p-5 sm:p-6 border-glow hover:glow-cyan transition-shadow duration-300 flex flex-col items-center text-center group">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-primary/10 flex items-center justify-center text-primary mb-4 sm:mb-5 group-hover:bg-primary/20 transition-colors">
                  {seg.icon}
                </div>
                <h3 className="font-display text-lg sm:text-xl text-foreground mb-2">{seg.title}</h3>
                <p className="text-sm text-muted-foreground font-body leading-relaxed mb-4 flex-1">
                  {seg.body}
                </p>
                <span className="font-mono text-xs text-gold bg-gold/10 px-3 py-1 rounded-full whitespace-nowrap">
                  {seg.stat}
                </span>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetSection;
